import React, { Component } from 'react';
import './App.css';
import { initWeb3 } from "./actions/web3Actions"
import { refreshPosts, newPost, updatePostInputText } from "./actions/wallActions"
import { connect } from "react-redux"

const stateMap = (store) => {
    return {
      posts: store.wall.posts,
      text: store.wall.text,
      web3Instance :store.web3.web3Instance,
      ipfsInstance :store.web3.ipfsInstance,
      theWallContract: store.web3.theWallContract
  };
};
class App extends Component {

  constructor(props, context) {
    super(props);
    
    // This binding is necessary to make `this` work in the callback
    this.refreshPosts = this.refreshPosts.bind(this);
    this.newPost = this.newPost.bind(this);
    this.updatePostInputText = this.updatePostInputText.bind(this);
  }

  componentWillMount() {

    const { web3Instance, ipfsInstance, theWallContract } = this.props;

    if(web3Instance === null && ipfsInstance === null) {
      this.props.dispatch(initWeb3({
        web3Instance,
        ipfsInstance,
        theWallContract
      }));
    }
  }

  refreshPosts() {
    this.props.dispatch(refreshPosts())
  }

  newPost() {
    this.props.dispatch(newPost(this.props.text))
  }

  updatePostInputText(event) {
    this.props.dispatch(updatePostInputText(event.target.value))
  }

  render() {

    const { posts, text } = this.props;
    const mappedPosts = posts.map(post => <div className="postContent" key={post.id}>{post.text}</div>)

    return (
      <div className="App">
        <header className="App-header">
          <h1 className="App-title">Ethereum Wall. Pay 0.1 eth on Rinkeby to post.</h1>
        </header>

        <div className="bodyCnt">
          <textarea className="newPostText" value={text} onChange={this.updatePostInputText.bind(this)} />
          <button className="newPostButton" onClick={this.newPost.bind(this)}>New post</button>
          <div className="gap"></div>
          <div className="postCnt">{mappedPosts}</div>
        </div>

      </div>
    );
  }
}

export default connect(stateMap)(App);



// WEBPACK FOOTER //
// ./src/App.js